import styled, { css } from '@app/styled';
import { zIndex } from '@app/theme';

import { promoContainer } from '../Promo';

export const Container = styled.div`
    ${promoContainer}
    position: relative;
`;
export const TriggerWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;
export const TriggerElement = styled.button`
    display: block;
    width: 100%;
    border: none;
    padding: 0;
    background-color: transparent;
    text-align: left;
`;

export const wistiaOverrideStyles = css`
    .wistia_popover_overlay {
        z-index: ${zIndex('wistiaPopoverOverlay')} !important; // Overriding inline styles so !important is necessary
    }
    .wistia_popover_embed {
        z-index: ${zIndex('wistiaPopoverEmbed')} !important; // Overriding inline styles so !important is necessary
    }
`;
